import type { Command } from '../../types/commands'
import { getCurrentDirectory } from '../../utils/contextUtils'

export const pwdCommand: Command = {
  name: 'pwd',
  description: 'Print working directory',
  category: 'navigation',
  execute: (_args, context) => {
    const currentDir = getCurrentDirectory(context)

    return [
      {
        type: 'info',
        content: currentDir,
      },
    ]
  },
}
